import { IErrorItem } from "../../../alert/alertHelpers";

export interface ICellStyleConfig {
    errorBackgroundColor?: string;
    errorTextColor?: string;
    errorClassName?: string;
    normalClassName?: string;
}

const defaultConfig: ICellStyleConfig = {
    errorBackgroundColor: '#fbda00',
    errorTextColor: '#000000',
    errorClassName: 'gridRowCellError',
    normalClassName: 'gridRowCellNormal',
};

export const shouldHighlightCell = (
    item: IErrorItem | null | undefined,
    propertyName: string
): boolean => {
    return (
        item?.alerts?.some(alert => alert.field.includes(propertyName)) ?? false
    );
};

export default defaultConfig;